export default {
  "ad.changePw": "Cambiar contraseña",
  "ad.logout": "Salir",
  "cf.language": "Idioma",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.edit": "Editar",
  "common.delete": "Eliminar",
  "common.search": "Buscar",
  "common.loading": "Cargando...",
  "common.confirm": "Confirmar",
  "common.back": "Volver",
  "common.yes": "Sí",
  "common.no": "No",
  "dash.title": "Panel",
  "dash.today": "Hoy",
  "dash.week": "Semana",
  "dash.month": "Mes",
  "dash.fiado": "Fiado pendiente",
  "dash.salesDone": "Ventas concluidas",
  "dash.openOrders": "Pedidos abiertos",
  "dash.openOS": "OS abiertas",
  "dash.lowStock": "Stock bajo",
  "dash.rev30": "Facturación — últimos 30 días",
  "dash.topProducts": "Top Productos",
  "dash.sellers": "Vendedores",
  "dash.noData": "Sin datos",
  "dash.product": "Producto",
  "dash.qty": "Cant.",
  "dash.revenue": "Ingresos",
  "dash.seller": "Vendedor",
  "dash.sales": "Ventas",
  "dash.total": "Total",
  "dash.reports": "Informes",
  "dash.lowStockTitle": "Stock Bajo",
  "dash.belowMin": "{n} productos debajo del mínimo",
  "dash.print": "Imprimir",
  "dash.stock": "Stock",
  "dash.min": "Mínimo",
  "dash.missing": "Falta",
  "dash.unitPrice": "Precio Unit.",
  "dash.totalSale": "Total Venta",
  "dash.restock": "Total para reponer:",
  "login.tagline": "Del caos a la claridad — Aurora ilumina tu gestión",
  "login.title": "Entrar a tu cuenta",
  "login.password": "Contraseña",
  "login.enter": "Entrar",
  "login.loggingIn": "Entrando...",
  "login.plans": "Ver planes y precios",
  "login.noAccount": "¿Aún no tienes cuenta?",
  "login.trial": "Prueba Gratis 15 días ☀",
  "menu.dashboard": "Panel",
  "menu.clients": "Clientes",
  "menu.products": "Productos y Stock",
  "menu.sales": "Ventas",
  "menu.os": "Órdenes de Servicio",
  "menu.trocas": "Cambios y Devoluciones",
  "menu.cash": "Caja",
  "menu.financial": "Finanzas",
  "menu.reports": "Informes",
  "menu.fiscal": "Factura",
  "menu.support": "Soporte",
  "menu.config": "Configuración",
  "menu.admin": "Panel Admin",
  "os.title": "Órdenes de Servicio",
  "os.count": "{n} registradas",
  "os.new": "+ Nueva OS",
  "os.fAll": "Todas",
  "os.fOpen": "Abiertas",
  "os.fRepair": "En reparación",
  "os.fDone": "Finalizadas",
  "os.fPaid": "Pagadas",
  "os.fCanceled": "Canceladas",
  "os.client": "Cliente",
  "os.desc": "Descripción",
  "os.total": "Total",
  "os.status": "Estado",
  "os.actions": "Acciones",
  "os.view": "Ver",
  "os.start": "Iniciar",
  "os.finish": "Finalizar",
  "os.cancelConfirm": "¿Cancelar OS #{n}? El stock será revertido.",
  "os.editTitle": "Editar OS",
  "os.osNum": "OS Nº",
  "os.labor": "Mano de obra",
  "os.parts": "Piezas utilizadas",
  "os.searchPart": "Buscar pieza...",
  "os.part": "Pieza",
  "os.qty": "Cant.",
  "os.value": "Valor",
  "os.subtotal": "Subtotal",
  "os.partsSum": "Piezas",
  "os.saving": "Guardando...",
  "os.tech": "Técnico",
  "os.item": "Ítem",
  "os.print": "Imprimir",
  "os.printTitle": "ORDEN DE SERVICIO No",
  "os.newTitle": "Nueva OS",
  "os.newClient": "+ Nuevo",
  "os.promptName": "Nombre del cliente:",
  "os.promptPhone": "Teléfono (opcional):",
  "os.promptType": "Tipo: PF, PJ o Reventa",
  "os.select": "Seleccione...",
  "os.obs": "Obs",
  "os.descPh": "Ej: Cambio de pantalla iPhone 12",
  "os.totalValue": "Valor Total de la OS",
  "os.create": "Crear OS",
  "os.exceed": "⚠ Las piezas exceden el valor total de la OS",
  "os.error": "Error: ",
  "st.em_aberto": "abierta",
  "st.em_reparo": "en reparación",
  "st.finalizado": "finalizada",
  "st.pago": "pagada",
  "st.cancelado": "cancelada",
  "cl.title": "Clientes",
  "cl.count": "{n} registrados",
  "cl.exportCsv": "Exportar CSV",
  "cl.importCsv": "Importar CSV",
  "cl.new": "+ Nuevo",
  "cl.searchPh": "Buscar...",
  "cl.debtors": "Deudores",
  "cl.credit": "Crédito",
  "cl.name": "Nombre",
  "cl.type": "Tipo",
  "cl.phone": "Teléfono",
  "cl.city": "Ciudad",
  "cl.debt": "Deuda",
  "cl.actions": "Acciones",
  "cl.deleteConfirm": "¿Seguro que deseas eliminar este cliente?",
  "cl.importEmpty": "Ningún cliente encontrado en el archivo",
  "cl.importConfirm": "¿Importar {n} clientes?",
  "cl.formEdit": "Editar cliente",
  "cl.formNew": "Nuevo cliente",
  "cl.ficha": "Ficha del Cliente",
  "cl.creditBalance": "Saldo de Crédito",
  "cl.hasCredit": "Cliente tiene crédito disponible",
  "cl.hasDebt": "Cliente tiene deuda pendiente",
  "cl.noBalance": "Sin saldo",
  "cl.history": "Historial",
  "cl.noMoves": "Ningún movimiento",
  "cl.payDebt": "Abonar Deuda",
  "cl.amount": "Valor",
  "cl.method": "Método",
  "cl.cash": "Efectivo",
  "cl.card": "Tarjeta",
  "cl.other": "Otro",
  "cl.obsLabel": "Observación",
  "cl.obsMandatory": " (obligatorio)",
  "cl.obsPh": "Servicio cambiado, material enviado...",
  "cl.obsRequired": "Observación obligatoria para pago tipo Otro",
  "cl.processing": "Procesando...",
  "cl.confirmPay": "Confirmar Pago",
  "cl.error": "Error: ",
  "sl.title": "Ventas",
  "sl.tabNew": "Nueva venta",
  "sl.tabOrders": "Pedidos",
  "sl.tabSearch": "Consultar",
  "sl.searchProdPh": "Buscar por nombre del producto...",
  "sl.searching": "Buscando...",
  "sl.noResults": "Ningún resultado",
  "sl.minChars": "Escribe al menos 2 caracteres",
  "sl.order": "Pedido",
  "sl.date": "Fecha",
  "sl.client": "Cliente",
  "sl.seller": "Vendedor",
  "sl.product": "Producto",
  "sl.qty": "Cant.",
  "sl.price": "Precio",
  "sl.status": "Estado",
  "sl.walkin": "Ocasional",
  "sl.noPerm": "Sin permiso",
  "sl.orderOpened": "¡Pedido abierto!",
  "sl.retail": "Minorista",
  "sl.wholesale": "Mayorista",
  "sl.searchClientPh": "Buscar cliente...",
  "sl.creditAvail": "Crédito disponible: ",
  "sl.debtPending": "Deuda pendiente: ",
  "sl.searchProdPh2": "Buscar producto...",
  "sl.addProducts": "Agrega productos",
  "sl.discCol": "Desc. R$",
  "sl.obsPh": "Observación (opcional)",
  "sl.summary": "Resumen",
  "sl.disc": "Desc.",
  "sl.discShort": "Desc",
  "sl.saveChanges": "Guardar Cambios",
  "sl.openOrder": "Abrir pedido",
  "sl.fAll": "Todos",
  "sl.fOpen": "Abiertos",
  "sl.fFiado": "Fiado",
  "sl.fDone": "Finalizados",
  "sl.payment": "Pago",
  "sl.reopen": "Reabrir",
  "sl.orderCaps": "PEDIDO",
  "sl.printOrder": "PEDIDO Nº",
  "sl.discItems": "Desc. ítems",
  "sl.discGeneral": "Desc. general",
  "sl.payMethods": "Formas de Pago:",
  "sl.payMethod": "Forma de Pago:",
  "sl.payAtCash": "El pago debe realizarse en la Caja",
  "sl.fiadoConfirm": "¿Marcar pedido #{n} como FIADO? El valor se registrará como deuda del cliente.",
  "sl.sellFiado": "Vender Fiado (a plazo)",
  "sl.fiadoNotice": "FIADO — Pendiente de pago. Cobra en la Caja para saldar.",
  "sl.error": "Error: ",
  "st.aberto": "abierto",
  "st.fiado": "fiado",
  "st.concluído": "concluido",
  "pr.title": "Productos y Stock",
  "pr.count": "{n} registrados",
  "pr.allCats": "Todas",
  "pr.brand": "Marca",
  "pr.category": "Categoría",
  "pr.stock": "Stock",
  "pr.min": "Mínimo",
  "pr.label": "Etiqueta",
  "pr.deleteConfirm": "¿Seguro que deseas eliminar este producto?",
  "pr.importEmpty": "Ningún producto encontrado en el archivo",
  "pr.importConfirm": "¿Importar {n} productos?",
  "pr.prev": "Anterior",
  "pr.next": "Siguiente",
  "pr.pageOf": "Página {a} de {b} ({n} productos)",
  "pr.ficha": "Ficha del Producto",
  "pr.currentStock": "Stock Actual",
  "pr.addStock": "Cargar Stock",
  "pr.launch": "+ Cargar",
  "pr.stockLoad": "Carga de stock",
  "pr.reasonPh": "Motivo (ej: Compra proveedor)",
  "pr.reason": "Motivo",
  "pr.moves": "Movimientos",
  "pr.noMoves": "Ningún movimiento registrado",
  "pr.formEdit": "Editar",
  "pr.formNew": "Nuevo",
  "pr.newCat": "+ Nueva",
  "pr.newCatPrompt": "Nombre de la nueva categoría:",
  "pr.cost": "Costo",
  "pr.tiers": "Precios por Volumen",
  "pr.tiersClose": "▲ Cerrar",
  "pr.tiersAdd": "▼ Agregar",
  "pr.from": "A partir de",
  "pr.unitArrow": "und →",
  "pr.addTier": "+ Agregar rango",
  "pr.error": "Error: ",
  "st.entrada": "entrada",
  "st.saida": "salida",
  "tr.tabMain": "Cambios/Devoluciones",
  "tr.tabSupplier": "Dev. proveedor",
  "tr.new": "+ Nuevo Cambio/Devolución",
  "tr.formTitle": "Nuevo Cambio / Devolución",
  "tr.byOrder": "Por Nº Pedido",
  "tr.byProduct": "Por Producto",
  "tr.orderNum": "Nº del Pedido",
  "tr.orderNumPh": "Escribe el número del pedido...",
  "tr.productName": "Nombre del Producto",
  "tr.productNamePh": "Escribe el nombre del producto...",
  "tr.notFinalized": "Pedido #{n} no está finalizado (estado: {s})",
  "tr.notFound": "Pedido #{n} no encontrado",
  "tr.noSaleFound": "Ninguna venta encontrada con ese producto",
  "tr.consumer": "Consumidor",
  "tr.opType": "Tipo de Operación",
  "tr.return": "Devolución",
  "tr.exchange": "Cambio",
  "tr.selectItems": "Ítems del Pedido — selecciona el/los que serán devueltos",
  "tr.returnCol": "Devolver",
  "tr.returnedTotal": "Total devuelto:",
  "tr.newProducts": "Producto(s) Nuevo(s)",
  "tr.newProdPh": "Buscar producto nuevo...",
  "tr.stAbbr": "stk",
  "tr.newProduct": "Producto Nuevo",
  "tr.newTotal": "Total nuevo:",
  "tr.returnedValue": "Valor devuelto:",
  "tr.newValue": "Valor nuevo:",
  "tr.difference": "Diferencia:",
  "tr.noDiff": "Sin diferencia",
  "tr.clientReceives": "Cliente recibe ",
  "tr.clientPays": "Cliente paga ",
  "tr.howCredit": "¿Cómo resolver el crédito?",
  "tr.howDebit": "¿Cómo resolver el débito?",
  "tr.creditFicha": "Crédito en la ficha",
  "tr.debitFicha": "Débito en la ficha",
  "tr.refundPix": "Devolver Bizum",
  "tr.chargePix": "Cobrar Bizum",
  "tr.refundCash": "Devolver efectivo",
  "tr.chargeCash": "Cobrar efectivo",
  "tr.refundCard": "Devolver tarjeta",
  "tr.chargeCard": "Cobrar tarjeta",
  "tr.obsOptional": "Observación (opcional)",
  "tr.obsPh": "Motivo del cambio/devolución...",
  "tr.returned": "Devueltos",
  "tr.newOnes": "Nuevos",
  "tr.credit": "Crédito",
  "tr.debit": "Débito",
  "tr.onFicha": "Registrado en la ficha del cliente",
  "tr.via": "Vía ",
  "tr.success": "realizado con éxito!",
  "tr.resolution": "Resolución",
  "tr.none": "Ningún cambio/devolución registrado",
  "tr.noneF": "Ninguna",
  "tr.cancelTitle": "Cancelar Cambio/Devolución",
  "tr.cancelWarn": "Esta acción revertirá stock, crédito del cliente y registros financieros.",
  "tr.reasonOptional": "Motivo (opcional)",
  "tr.cancelReasonPh": "Motivo de la cancelación...",
  "tr.cancelling": "Cancelando...",
  "tr.confirmCancel": "Confirmar Cancelación",
  "tr.supplier": "Proveedor",
  "tr.error": "Error: ",
  "tr.cancelError": "Error al cancelar: ",
  "st.troca": "cambio",
  "st.devolucao": "devolución",
  "st.concluido": "concluido",
  "cx.title": "Caja",
  "cx.open": "Caja abierta",
  "cx.closed": "Caja cerrada",
  "cx.tabCash": "Caja",
  "cx.tabMoves": "Movimientos",
  "cx.tabConf": "Conferencia",
  "cx.openCash": "Abrir Caja",
  "cx.initial": "Valor inicial (cambio)",
  "cx.opening": "Abriendo...",
  "cx.cashMsg": "¡Caja abierta!",
  "cx.receive": "Recibir Pagos",
  "cx.noItems": "Sin ítems",
  "cx.selectPending": "Selecciona un pedido pendiente",
  "cx.discount": "Descuento",
  "cx.or": "o",
  "cx.payForm": "Forma de Pago",
  "cx.useCredit": "Usar Crédito",
  "cx.saleTotal": "Total de la Venta",
  "cx.received": "Total Recibido",
  "cx.change": "Cambio (efectivo)",
  "cx.fiado": "Fiado",
  "cx.selectMethod": "Selecciona forma de pago",
  "cx.printReceipt": "¿Imprimir recibo?",
  "cx.fiadoMsg": "¡Registrado como fiado!",
  "cx.payMsg": "¡Pago confirmado!",
  "cx.sangria": "Retiro de caja",
  "cx.suprimento": "Ingreso de caja",
  "cx.reason": "Motivo",
  "cx.sangriaMsg": "¡Retiro registrado!",
  "cx.suprimMsg": "¡Ingreso registrado!",
  "cx.sangriaDefault": "Retiro",
  "cx.suprimDefault": "Ingreso",
  "cx.pending": "Pedidos Pendientes",
  "cx.noPending": "Ninguno pendiente",
  "cx.closeCash": "Cerrar Caja",
  "cx.expected": "Saldo esperado:",
  "cx.credits": "Créditos",
  "cx.optional": "Opcional",
  "cx.closing": "Cerrando...",
  "cx.matched": "Cuadró perfecto ✓",
  "cx.over": "Sobra R$ ",
  "cx.short": "Falta R$ ",
  "cx.reported": "Reportado",
  "cx.movesTitle": "Movimientos de la Caja",
  "cx.histTitle": "Historial de Cajas",
  "cx.opened": "Apertura",
  "cx.closedAt": "Cierre",
  "cx.operator": "Operador",
  "cx.initialCol": "Inicial",
  "cx.expectedCol": "Esperado",
  "cx.diff": "Diferencia",
  "cx.noClosed": "Ninguna caja cerrada",
  "cx.matchShort": "✓ Cuadró",
  "cx.check": "Revisar",
  "cx.confTitle": "Conferencia de Caja",
  "cx.openLbl": "abierta",
  "cx.matchedShort": "Cuadró ✓",
  "cx.hour": "Hora",
  "cx.products": "Productos",
  "cx.paymentCol": "Pago",
  "cx.balance": "Saldo",
  "cx.sangrias": "Retiros",
  "cx.suprimentos": "Ingresos",
  "cx.estornos": "Reversiones",
  "cx.prazo": "Plazo",
  "cx.searchPh": "Buscar pedido, cliente...",
  "cx.noMoves": "Ningún movimiento",
  "cx.detailsUnavail": "Detalles no disponibles",
  "cx.discItem": "Desc Ítem",
  "cx.discGeneralLine": "Descuento general:",
  "st.venda": "venta",
  "st.divida": "deuda",
  "st.pagamento_venda": "pago venta",
  "st.pagamento_os": "pago OS",
  "st.pagamento_divida": "pago deuda",
  "st.estorno_reabertura": "reversión reapertura",
  "st.ajuste_edicao": "ajuste edición",
  "st.cancelamento": "cancelación",
  "st.sangria": "retiro",
  "st.suprimento": "ingreso",
  "pay.pix": "Bizum",
  "fn.title": "Finanzas",
  "fn.count": "{n} registros",
  "fn.tabSummary": "Resumen",
  "fn.tabPay": "A Pagar",
  "fn.tabReceive": "A Cobrar",
  "fn.required": "Descripción y valor obligatorios",
  "fn.created": "¡Registro creado!",
  "fn.paidMsg": "¡Marcado como pagado!",
  "fn.deleteConfirm": "¿Eliminar registro?",
  "fn.receivedLbl": "Cobrado:",
  "fn.paidLbl": "Pagado:",
  "fn.pendingLbl": "Pendiente:",
  "fn.balanceLbl": "Saldo (realizado)",
  "fn.inOut": "Entradas - Salidas efectivas",
  "fn.overdue": "Vencidos",
  "fn.dueSoon": "Vencen en 5 días",
  "fn.dueAbbr": "venc.",
  "fn.pay": "Pagar",
  "fn.receive": "Cobrar",
  "fn.new": "+ Nuevo Registro",
  "fn.newTitle": "Nuevo Registro",
  "fn.allStatus": "Todos los estados",
  "fn.pending": "Pendiente",
  "fn.paid": "Pagado",
  "fn.catPh": "Ej: Proveedor, Alquiler",
  "fn.due": "Vencimiento",
  "fn.supplierOrigin": "Proveedor/Origen",
  "fn.none": "Ningún registro",
  "st.pendente": "pendiente",
  "rp.title": "Informes",
  "rp.results": "{n} resultados",
  "rp.filters": "Filtros",
  "rp.dateFrom": "Fecha desde",
  "rp.dateTo": "Fecha hasta",
  "rp.dateFmt": "DD/MM/AAAA",
  "rp.namePh": "Nombre...",
  "rp.commissionPct": "Comisión %",
  "rp.generate": "Generar informe",
  "rp.generating": "Generando...",
  "rp.clear": "Limpiar",
  "rp.revenue": "Facturación",
  "rp.orders": "Pedidos",
  "rp.avgTicket": "Ticket medio",
  "rp.itemsSold": "Ítems vendidos",
  "rp.noneFiltered": "Ningún pedido con esos filtros",
  "rp.byCat": "Por categoría",
  "rp.commissions": "Comisiones",
  "rp.commission": "Comisión",
  "rp.totalCaps": "TOTAL",
  "rp.hint": "Selecciona filtros y haz clic en Generar informe",
  "rp.noSeller": "Sin vendedor",
  "rp.noCat": "Sin cat.",
  "rp.error": "Error: ",
  "rp.printTitle": "Informe Aurora",
  "rp.printHeader": "Informe de Ventas",
  "rp.ordersLbl": "pedidos",
  "rp.itemsLbl": "ítems",
  "rp.generatedBy": "Generado por Aurora by Neurotech-X el",
  "fs.title": "Factura Electrónica (Brasil)",
  "fs.subtitle": "Configuración fiscal y emisión vía Focus NFe",
  "fs.tabNotes": "Facturas",
  "fs.tabConfig": "Configuración",
  "fs.issued": "Facturas Emitidas",
  "fs.refresh": "↻ Actualizar",
  "fs.emit": "+ Emitir Factura",
  "fs.none": "Ninguna factura emitida todavía",
  "fs.number": "Número",
  "fs.emitTitle": "Emitir Factura",
  "fs.clientOpt": "Cliente (opcional)",
  "fs.recipient": "Destinatario *",
  "fs.items": "Ítems *",
  "fs.addItem": "+ Ítem",
  "fs.unitPrice": "Valor Unit.",
  "fs.payment": "Pago *",
  "fs.addPay": "+ Forma",
  "fs.payForm": "Forma",
  "fs.valueEmpty": "Valor (vacío=total)",
  "fs.emitting": "Emitiendo...",
  "fs.emitBtn": "Emitir",
  "fs.authorized": "✅ ¡Factura autorizada! Nº ",
  "fs.sent": "⏳ Factura enviada",
  "fs.configSaved": "¡Configuración guardada!",
  "fs.error": "Error: ",
  "fs.saveConfig": "Guardar Configuración",
  "st.autorizada": "autorizada",
  "st.erro": "error",
  "tk.title": "Soporte",
  "tk.count": "{n} tickets",
  "tk.new": "+ Nuevo Ticket",
  "tk.tabOpen": "Abiertos",
  "tk.tabClosed": "Resueltos",
  "tk.noneOpen": "Ningún ticket abierto. ¡Todo bien! ☀",
  "tk.noneClosed": "Ningún ticket resuelto todavía.",
  "tk.newTitle": "Nuevo Ticket",
  "tk.newSub": "Describe tu problema o duda",
  "tk.back": "← Volver",
  "tk.subject": "Asunto *",
  "tk.subjectPh": "Ej: Error al finalizar venta",
  "tk.descPh": "Detalla el problema, pasos para reproducir...",
  "tk.priority": "Prioridad",
  "tk.creating": "Creando...",
  "tk.openTicket": "Abrir Ticket",
  "tk.subjectRequired": "Informa el asunto",
  "tk.rateRequired": "Selecciona una nota",
  "tk.supportName": "Soporte Neurotech-X",
  "tk.you": "Tú",
  "tk.attachment": "📎 Adjunto",
  "tk.noMessages": "Ningún mensaje todavía",
  "tk.rated": "Evaluaste esta atención",
  "tk.ratePrompt": "Ticket cerrado. ¿Deseas evaluar la atención? (opcional)",
  "tk.commentPh": "Comentario (opcional)",
  "tk.sending": "Enviando...",
  "tk.sendRating": "Enviar Evaluación",
  "tk.msgPh": "Escribe tu mensaje... (Enter para enviar)",
  "tk.send": "Enviar",
  "tk.st_aberto": "Abierto",
  "tk.st_em_atendimento": "En Atención",
  "tk.st_fechado": "Cerrado",
  "tk.pr_baixa": "baja",
  "tk.pr_normal": "normal",
  "tk.pr_alta": "alta",
  "tk.pr_urgente": "urgente",
  "cf.title": "Configuración",
  "cf.subtitle": "Gestiona tu empresa y usuarios",
  "cf.tabCompany": "Datos de la Empresa",
  "cf.tabUsers": "Usuarios y Permisos",
  "cf.tabLabels": "Etiquetas",
  "cf.companyInfo": "Información de la Empresa",
  "cf.companyName": "Nombre de la Empresa *",
  "cf.companyNameLbl": "Nombre de la Empresa",
  "cf.address": "Dirección",
  "cf.addressPh": "Calle, número, barrio",
  "cf.state": "Estado",
  "cf.logoUrl": "URL del Logo (opcional)",
  "cf.logoHint": "El logo aparecerá en los impresos (pedidos, OS). Recomendado: imagen PNG hasta 200x80px.",
  "cf.logoPreview": "Vista previa del logo:",
  "cf.saveCompany": "Guardar Datos de la Empresa",
  "cf.companySaved": "¡Datos de la empresa guardados!",
  "cf.headerPreview": "Vista previa del Encabezado (impresos)",
  "cf.labelConfig": "Configurar Modelo de Etiqueta",
  "cf.labelHint": "Configura el tamaño y los campos que aparecerán en las etiquetas de tus productos. El modelo se usará al imprimir etiquetas en la pantalla de Productos.",
  "cf.width": "Ancho (mm)",
  "cf.height": "Alto (mm)",
  "cf.fontSize": "Tamaño de Fuente (px)",
  "cf.labelFields": "Campos de la Etiqueta (activa/desactiva)",
  "cf.fName": "Nombre del Producto",
  "cf.fRetail": "Precio Minorista",
  "cf.fWholesale": "Precio Mayorista",
  "cf.fLogo": "Logo de la Empresa",
  "cf.fBarcode": "Código de Barras",
  "cf.saveLabel": "Guardar Modelo de Etiqueta",
  "cf.labelPreview": "Vista previa de la Etiqueta",
  "cf.sampleProduct": "Producto Ejemplo",
  "cf.realSize": "Tamaño real:",
  "cf.scale3x": "(vista previa en escala 3x)",
  "cf.usersCount": "{n} usuarios",
  "cf.newUser": "+ Nuevo Usuario",
  "cf.newUserTitle": "Nuevo Usuario",
  "cf.create": "Crear",
  "cf.fillAll": "Completa todos los campos",
  "cf.userCreated": "¡Usuario creado!",
  "cf.active": "Activo",
  "cf.inactive": "Inactivo",
  "cf.resetPassword": "Restablecer Contraseña",
  "cf.resetPrompt": "Nueva contraseña para {n} (deja VACÍO para generar una automática):",
  "cf.tempPassword": "Contraseña temporal de {n} — copia ahora, no se mostrará de nuevo:",
  "cf.resetDone": "¡Contraseña restablecida! El usuario deberá cambiarla en el próximo login.",
  "cf.permissions": "Permisos",
  "cf.module": "Módulo",
  "cf.specialPerms": "Permisos Especiales",
  "cf.capDiscount": "Dar Descuento",
  "cf.capReopen": "Reabrir Pedido",
  "cf.capCancel": "Cancelar Pedido",
  "cf.capFiado": "Vender Fiado",
  "cf.capCloseCash": "Cerrar Caja",
  "cf.capConference": "Ver Conferencia",
  "cf.savePerms": "Guardar Permisos",
  "cf.permsSaved": "¡Permisos guardados!",
  "cf.modExchanges": "Cambios",
  "cf.modFiscal": "Fiscal",
  "pl.title": "Planes Aurora",
  "pl.subtitle": "Elige el plan ideal para tu negocio",
  "pl.popular": "MÁS POPULAR",
  "pl.select": "SELECCIONAR",
  "pl.perMonth": "/mes",
  "pl.includes": "INCLUYE:",
  "pl.users": "{n} usuarios",
  "pl.unlimited": "Ilimitados",
  "pl.subscribe": "Contratar",
  "pl.aiChip": "✓ Asistente Virtual IA *",
  "pl.aiTitle": "* Asistente Virtual IA — Incluida en todos los planes",
  "pl.aiDesc1": "Todos los planes Aurora incluyen",
  "pl.aiDesc2": ", nuestra asistente virtual inteligente desarrollada por Neurotech-X. Te guía paso a paso en el uso del sistema, resuelve dudas sobre módulos, funcionalidades, planes y configuraciones, orienta en la migración de datos de otros sistemas (Nex, Bling, Tiny, planillas), y cuando es necesario, abre tickets de soporte técnico automáticamente — todo dentro del propio sistema, en tiempo real.",
  "pl.aiMore": "¿Quieres conocer más sobre nuestras soluciones de IA? Conoce nuestros talentos virtuales en",
  "pl.backToLogin": "← Volver al login",
  "pl.descStarter": "Ideal para quien está empezando.",
  "pl.descEssencial": "Para negocios en crecimiento.",
  "pl.descPro": "Gestión completa con finanzas e informes.",
  "pl.descBusiness": "Para operaciones robustas y multiusuario.",
  "pl.descEnterprise": "Solución completa para grandes operaciones.",
  "tf.subscribePlan": "Contratar plan",
  "tf.createAccount": "Crear cuenta",
  "tf.planHint": "Tu plan se activará en cuanto el pago sea procesado. ¡Mientras tanto, disfruta del acceso completo!",
  "tf.fillHint": "Completa tus datos para empezar.",
  "tf.companyName": "Nombre de la empresa *",
  "tf.companyPh": "Ej: Tienda de Juan",
  "tf.companyEmail": "Email de la empresa *",
  "tf.accessData": "Datos de Acceso",
  "tf.yourName": "Tu nombre *",
  "tf.fullNamePh": "Nombre completo",
  "tf.passwordPh": "Mínimo 6 caracteres",
  "tf.passwordMin": "La contraseña debe tener al menos 6 caracteres",
  "tf.createError": "Error al crear la cuenta",
  "tf.creating": "Creando tu cuenta...",
  "tf.createAndSubscribe": "Crear cuenta y contratar",
  "ad.panel": "Panel Admin",
  "ad.deletePerm": "Eliminar Permanentemente",
  "ad.actives": "Activos",
  "ad.canceled": "Cancelados",
  "ad.loadingMetrics": "Cargando métricas...",
  "ad.loadingPlans": "Cargando planes...",
  "ad.loadingTenants": "Cargando tenants...",
  "ad.supportTickets": "Tickets de Soporte",
  "ad.createdAt": "Creado el",
  "ad.adminPassPrompt": "Escribe tu contraseña de administrador:",
  "ad.document": "Documento",
  "ad.companyEmail": "Email de la Empresa *",
  "ad.masterEmail": "Email del Master *",
  "ad.dashError": "Error al cargar el panel",
  "ad.closeTicket": "Cerrar Ticket",
  "ad.avgMrr": "MRR Promedio por Tenant",
  "ad.maxUsers": "Máx. Usuarios",
  "ad.modulesIncluded": "Módulos Incluidos",
  "ad.modulesEnabled": "Módulos habilitados",
  "ad.noTenants": "Ningún tenant registrado",
  "ad.noTenantsFound": "Ningún tenant encontrado",
  "ad.masterName": "Nombre del Master *",
  "ad.planName": "Nombre del Plan *",
  "ad.new30": "Nuevos (30 días)",
  "ad.popularPlan": "Plan Más Popular",
  "ad.planReq": "Plan *",
  "ad.plan": "Plan",
  "ad.monthlyPrice": "Precio Mensual (R$) *",
  "ad.resetPass": "Restablecer contraseña",
  "ad.selectPlan": "Selecciona un plan",
  "ad.noPlan": "Sin plan",
  "ad.masterPass": "Contraseña del Master *",
  "ad.tenantsStatus": "Estado de los Tenants",
  "ad.storage": "Almacenamiento (MB)",
  "ad.suspended": "Suspendidos",
  "ad.activeTenants": "Tenants Activos",
  "ad.allStatus": "Todos los estados",
  "ad.totalTenants": "Total de Tenants",
  "ad.masterUser": "Usuario Master",
  "ad.totalUsers": "Usuarios Totales",
  "ad.users": "Usuarios",
  "ad.lastLogin": "Último Login",
  "ad.recentTenants": "Últimos Tenants Registrados",
  "ad.allDataOf": "Todos los datos de",
  "ad.searchPh": "Buscar por nombre o email...",
  "ad.planDescPh": "Descripción corta del plan",
  "ad.planNamePh": "Ej: Premium",
  "ad.replyPh": "Responder al cliente...",
  "ad.adminPassPh": "Contraseña del admin",
  "ad.closeTicketConfirm": "¿Cerrar este ticket?"
};
